import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { LandingHeader } from '../components/layout/landing-header';

const AboutPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <LandingHeader currentPage="about" />

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h2 className="text-4xl font-bold text-gray-900 mb-8">About PageMind</h2>
        
        <div className="prose prose-lg text-gray-600">
          <p>
            PageMind was founded with a simple mission: to make every website more helpful and engaging 
            through the power of AI-driven conversations.
          </p>
          
          <h3 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Our Story</h3>
          <p>
            In May 2025, we noticed that while websites contained valuable information, visitors often struggled 
            to find what they needed. Traditional search boxes and navigation menus weren't enough. We believed 
            there had to be a better way.
          </p>
          <p>
            That's when we created PageMind - an AI assistant that understands your website's content and can 
            have natural conversations with visitors, helping them find information, answer questions, and take action.
          </p>
          
          <h3 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Our Values</h3>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              <strong>Privacy First:</strong> We believe in protecting user data and never training on customer content 
              without explicit permission.
            </li>
            <li>
              <strong>Simplicity:</strong> Advanced AI shouldn't require a PhD to implement. Our one-line script 
              makes it easy for anyone.
            </li>
            <li>
              <strong>Accuracy:</strong> We're committed to providing truthful, relevant responses based solely 
              on your website's content.
            </li>
            <li>
              <strong>Continuous Improvement:</strong> We're constantly evolving our AI to better understand 
              and serve your visitors.
            </li>
          </ul>
          
          <h3 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Our Team</h3>
          <p>
            PageMind is built by a passionate team of AI researchers, engineers, and customer success specialists 
            who believe in the power of conversational AI to transform the web experience.
          </p>
          
          <h3 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Join Us</h3>
          <p>
            We're always looking for talented individuals who share our vision. If you're passionate about AI, 
            user experience, and making the web more accessible, we'd love to hear from you.
          </p>
          
          <div className="mt-12 flex justify-center">
            <Button size="lg" onClick={() => navigate('/contact')}>
              Get in Touch
            </Button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AboutPage;